<script setup lang="ts">
import Menu from '../components/Menu.vue'

defineProps<{
  logoUrl?: string
  profileImgUrl?: string
}>()
</script>

<template>
  <Menu>
    <template #activator="{ toggle }">
      <button
        data-component="user_menu"
        class="relative flex items-center rounded-full border border-neutral-300 lg:rounded-lg lg:border-neutral-200 lg:p-2 lg:py-1"
        data-analytics="top-bar-account-dropdown"
        @click="toggle()"
      >
        <img
          v-if="logoUrl"
          class="mr-3 hidden h-full max-h-5 w-full max-w-20 lg:inline-block"
          :src="logoUrl"
          alt="workspace logo"
        />
        <div>
          <div
            class="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-neutral-200"
          >
            <img
              v-if="profileImgUrl"
              class="absolute inset-0"
              :src="profileImgUrl"
              referrerpolicy="no-referrer"
            />
            <div v-else class="flex justify-center p-1">
              <div class="i-ph-user block h-6 w-6 text-neutral-500" />
            </div>
          </div>
        </div>
      </button>
    </template>
    <slot>
      <ul class="flex flex-col p-2">
        <li>
          <RouterLink
            to="/settings"
            class="user-menu-link"
            active-class="bg-primary-light text-white"
          >
            Settings
          </RouterLink>
        </li>
        <li>
          <button class="user-menu-link">Log out</button>
        </li>
      </ul>
    </slot>
  </Menu>
</template>

<style scoped>
.user-menu-link {
  @apply inline-flex w-full rounded-lg px-4 py-2 text-left text-sm font-light hover:bg-neutral-100 hover:text-neutral-800;
}
</style>
